import { useEffect, useRef, useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // You can use any icon library
import axios from 'axios';
// import Cookies from 'universal-cookie';
import Config from '../../../config';
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import { useDispatch } from 'react-redux';
import { SET_FORCE_LOGOUT_VAR } from "../../../store/property/common/commonProperty.actionsType";
import { LOADING_MODAL_CLOSE, LOADING_MODAL_OPEN } from "../../../store/actions";
import { PROPERTY_MASTER } from "../../../store/propertyMaster/propertyMaster.reducer";
import { useSelector } from '../../../store/reducer';

import { initialLoadCommon } from '../../../App/components/Common/Util';
import { useHistory, useLocation } from 'react-router-dom';
import superAdmin from '../../../menu-items-admin';
import { UNIT_MASTER } from "../../../store/unitMaster/unitMaster.reducer";
import { fetchYarnPOSalesOrderDropdown } from "../../../store/programs/YarnPO/yarnPO/yarnPO.actions";
import Swal from "sweetalert2";

export default function LoginForm({ onForgot, getUsersMenu, setLoading, loading }) {
    const usernameRef = useRef(null);
    const passwordRef = useRef(null);
    const [showPassword, setShowPassword] = useState(false);
    const [lastAutofilled, setLastAutofilled] = useState({ username: false, password: false });
    const [data, setData] = useState('')
    const [manuallyTyped, setManuallyTyped] = useState(false);
    const [errors, setErrors] = useState({});
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");


    let { ipAddressInfo } = useSelector((state) => {
        return state[PROPERTY_MASTER];
    });

    let { unitMaster } = useSelector((state) => {
        return state[UNIT_MASTER];
    });

    let { isLoaderModal } = useSelector((state) => {
        return state.able;
    });

    let dispatch = useDispatch();
    let history = useHistory();
    const location = useLocation();

    useEffect(() => {
        const inputs = [
            { ref: usernameRef, label: "Username", key: "username" },
            { ref: passwordRef, label: "Password", key: "password" }
        ];

        const checkColorChange = (input, key, label) => {
            const style = window.getComputedStyle(input);
            const bg = style.getPropertyValue("background-color");

            const isAutofilled =
                input.value &&
                bg !== "rgb(255, 255, 255)" &&
                bg !== "rgba(0, 0, 0, 0)";

            if (isAutofilled && !lastAutofilled[key]) {
                input.value = "";
                setPassword('')
                setUsername('')
                // alert(`${label} was autofilled!`);
                setLastAutofilled(prev => ({ ...prev, [key]: true }));
            } else if (!isAutofilled && lastAutofilled[key]) {
                setLastAutofilled(prev => ({ ...prev, [key]: false }));
            }
        };

        const interval = setInterval(() => {
            inputs.forEach(({ ref, label, key }) => {
                if (ref.current) checkColorChange(ref.current, key, label);
            });
        }, 300);

        return () => clearInterval(interval);
    }, [lastAutofilled]);

    // useEffect(() => {
    //     const input = passwordRef.current;
    //     if (!input) return;

    //     const computed = window.getComputedStyle(input);
    //     const bg = computed.getPropertyValue("background-color");

    //     const isAutofilled =
    //         input.value &&
    //         bg !== "rgb(255, 255, 255)" &&
    //         bg !== "rgba(0, 0, 0, 0)";

    //     if (isAutofilled && !manuallyTyped) {
    //         alert("Password field was autofilled!");
    //         input.value = ""; // clear it if needed
    //         setPassword('')
    //         setUsername('')
    //     }
    // }, [manuallyTyped]);



    useEffect(() => {
        setTimeout(() => {
            if (usernameRef.current) usernameRef.current.value = "";
            if (passwordRef.current) passwordRef.current.value = "";
        }, 800); // 100ms delay lets autofill finish, then clear it
    }, []);

    useEffect(() => {
        const timer = setTimeout(() => {
            const el = passwordRef.current;
            const style = getComputedStyle(el);
            const bg = style.getPropertyValue('background-color');

            const isAutofilled = el.value && bg !== 'rgb(255, 255, 255)';
            if (isAutofilled) {
                el.value = '';
                setPassword('')
                setUsername('')
            }
        }, 500);

        return () => clearTimeout(timer);
    }, []);


    // const isFromApp = true
    const isFromApp = navigator.userAgent.includes('eprotex-app');


    const checkLogin = async () => {
        const token = await Cookies.get('JWT_TOKEN')
        const dbname = await Cookies.get('DATABASE')

        if (token && dbname) {
            try {
                // Step 1: Validate user
                const response = await axios.get(
                    'https://eprotex.software/eprotex/eprov2api/api/TblDashboard/GetUserProfile',
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/json',
                            dbname,
                        },
                    }
                );

                if (!response?.data) {
                    dispatch({ type: LOADING_MODAL_CLOSE });
                    throw new Error('Invalid profile');

                }

                // Optional: Save user profile
                await localStorage.setItem('USER', JSON.stringify(response.data));

                // Step 2: Check permissions
                const menuRes = await axios.get(
                    'https://eprotex.software/eprotex/eprov2api/api/TblDashboard/GetUsersMenu',
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/json',
                            dbname,
                        },
                    }
                );

                const menus = menuRes.data || [];
                await localStorage.setItem('MENUS', JSON.stringify(menus));

                dispatch({ type: LOADING_MODAL_CLOSE });


                const hasPermission = menus.some((item) =>
                    (item.children || []).some((child) =>
                        child.title?.toLowerCase() === 'registered vendor'
                    )
                );

                if (hasPermission && isFromApp) {
                    dispatch({ type: LOADING_MODAL_CLOSE });
                    history.push('/registered-vendor');
                } else {
                    toast.error('No Menu Found')
                    dispatch({ type: LOADING_MODAL_CLOSE });
                    history.push('/auth/loginV2');
                }


            } catch (err) {
                console.log("❌ Auto login failed:", err.message);
                // await localStorage.clear();
                history.push('/auth/loginV2');
                dispatch({ type: LOADING_MODAL_CLOSE });


            }
        } else {
            console.log("➡️ Redirecting to login (no token/db)...");
            history.push('/auth/loginV2');
            dispatch({ type: LOADING_MODAL_CLOSE });

        }
    };

    useEffect(() => {
        if (isFromApp == true) {
            dispatch({ type: LOADING_MODAL_OPEN });
            setTimeout(() => {
                checkLogin();
            }, 1000)
        }
        return () => {
            dispatch({ type: LOADING_MODAL_CLOSE });
        }
    }, []);





    useEffect(() => {
        setTimeout(() => {
            const token = Cookies.get('JWT_TOKEN');
            const dbname = Cookies.get('DATABASE');
            if (token && dbname && location.pathname === '/auth/loginV2') {
                Swal.fire({
                    html: `
                <div class="custom-loader-container">
                  <div class="custom-loader"></div>
                  <div class="custom-loader"></div>
                  <div class="custom-loader"></div>
                  <div class="custom-loader"></div>
                  <p class="loading-text">Auto Login Please Wait....</p>
                </div>
              `,
                    text: 'Auto Login Please Wait...',
                    allowOutsideClick: false,
                    showConfirmButton: false,
                    customClass: {
                        popup: 'custom-popup'
                    }
                });
            } else {
                Swal.close();
            }
        }, 200); // delay to ensure values are populated
    }, [location.pathname]);





    useEffect(() => {
        if (isLoaderModal) {
            return Swal.fire({
                html: `
                  <div class="custom-loader-container">
                    <div class="custom-loader"></div>
                    <div class="custom-loader"></div>
                    <div class="custom-loader"></div>
                    <div class="custom-loader"></div>
                    <p class="loading-text">Processing Please Wait...</p>
                  </div>
                `,
                text: 'Please Wait...',
                allowOutsideClick: false,
                showConfirmButton: false,
                customClass: {
                    popup: 'custom-popup'
                }
            });
        } else {
            Swal.close();
        }
    }, [isLoaderModal]);



    const togglePasswordVisibility = () => {
        setShowPassword(prev => !prev);
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch({ type: LOADING_MODAL_OPEN });
        const newErrors = {};
        let hasError = false;

        if (!username.trim()) {
            newErrors.username = "Email is required";
            hasError = true;
        }
        if (!password.trim()) {
            newErrors.password = "Password is required";
            hasError = true;
        }

        setErrors(newErrors);


        if (!hasError) {
            setLoading(true)
            let data = {
                username: username,
                password: password
            };

            let cpheaders = {
                'Access-Control-Allow-Origin': true,
                'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
                'Content-Type': 'application/json'
            };


            axios
                .post(`${Config.baseUrl}/api/CPAuthenticate/login`, data, { cpheaders })
                .then((res) => {
                    Cookies.set('DATABASE', `${res.data.fldDatabase}`);
                    Cookies.set('USERID', `${res?.data?.fldUserName}`);
                    Cookies.set('PASSWORD', `${res?.data?.fldPassword}`);
                    Cookies.set('URL', Config.baseUrl);
                    let headers = {
                        'Access-Control-Allow-Origin': true,
                        'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
                        'Content-Type': 'application/json',
                        dbname: Cookies.get('DATABASE')
                    };
                    axios
                        .post(`${Config.baseUrl}/api/Authenticate/Login/login?FldIPAddress=${ipAddressInfo?.IPv4}`, data, { headers })
                        .then((res) => {
                            // Cookies.set('JWT_TOKEN', res.data);
                            Cookies.set('JWT_TOKEN', res.data[0].fldToken);



                            dispatch({ type: SET_FORCE_LOGOUT_VAR, payload: false });


                            localStorage.setItem('Login', JSON.stringify(data));

                            const config = {
                                headers: {
                                    Authorization: `Bearer ${Cookies.get('JWT_TOKEN')}`,
                                    'Access-Control-Allow-Origin': true,
                                    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
                                    'Content-Type': 'application/json',
                                    dbname: Cookies.get('DATABASE')
                                }
                            };

                            axios.post(
                                `${Config.baseUrl}/api/TblMail/CheckAllowedByIP?FldIpAddress=${ipAddressInfo?.IPv4}`,
                                {},
                                config
                            ).then((res) => {
                                dispatch({ type: LOADING_MODAL_CLOSE });

                            }).catch((error) => {
                                dispatch({ type: LOADING_MODAL_CLOSE });
                                console.error(error);
                            });

                            if (res?.data?.length === 1) {
                                axios
                                    .get(`${Config.baseUrl}/api/TblDashboard/GetUserProfile`, config)
                                    .then((res) => {
                                        Cookies.set('USER', JSON.stringify(res.data));
                                        Cookies.set('FKUser', JSON.stringify(res.data.fldFKUser));
                                        Cookies.set('FKCompany', JSON.stringify(res.data.fldFKCompany));
                                        let payload = JSON.parse(localStorage.getItem('Login'));

                                        if (payload.username !== 'cb@eprotex.software' && isFromApp !== true) {
                                            history.push('/bulk/dashboard');
                                            dispatch({ type: LOADING_MODAL_CLOSE });

                                        }
                                        initialLoadCommon(dispatch)
                                        setLoading(false)
                                        if (res.data.fldRole === 'Super Admin') {
                                            localStorage.setItem('MENUS', JSON.stringify(superAdmin));
                                            if (isFromApp == true) {
                                                history.push('/registered-vendor');
                                                dispatch({ type: LOADING_MODAL_CLOSE });

                                            }
                                        } else {
                                            getUsersMenu()

                                        }

                                    })
                                    // .then(() => {
                                    //     if (unitMaster.length === 0) {
                                    //         dispatch(fetchYarnPOSalesOrderDropdown(unitMaster[0].fldId));
                                    //     }
                                    // })
                                    .catch((err) => {
                                        toast.error(err?.response?.data);
                                        dispatch({ type: LOADING_MODAL_CLOSE });

                                    });
                            }
                            else {
                                history.push({
                                    pathname: '/company',
                                    state: { companies: res.data } // Pass the entire array of companies
                                });
                            }

                            dispatch({ type: LOADING_MODAL_CLOSE });

                        })
                        .catch((err) => {
                            toast.error(err?.response?.data);
                            dispatch({ type: LOADING_MODAL_CLOSE });
                            setLoading(false)
                            if (err?.response?.data?.status == 401) {
                                toast.error('Invalid Credentials');
                            }
                            if (err?.response?.data == 'User already logged in') {
                                dispatch({ type: SET_FORCE_LOGOUT_VAR, payload: true });
                            } else {
                                dispatch({ type: SET_FORCE_LOGOUT_VAR, payload: false });
                            }
                        });
                })
                .catch((err) => {
                    toast.error('Invalid Credentials');
                    setLoading(false)
                    dispatch({ type: LOADING_MODAL_CLOSE });
                });


        } else {
            dispatch({ type: LOADING_MODAL_CLOSE });

        }
    };


    return (
        // <div style={{
        //     display: "flex",
        //     justifyContent: "center",
        //     alignItems: "center",
        //     height: "100vh",
        //     width: "100%",
        //     // backgroundImage: "url('https://img.freepik.com/free-vector/isometric-erp-illustration_52683-84174.jpg?ga=GA1.1.1338093985.1743762455&semt=ais_hybrid&w=740')",

        //     // backgroundImage: "url('https://img.freepik.com/free-photo/3d-render-grunge-style-interior-design_1048-13616.jpg?ga=GA1.1.1338093985.1743762455&semt=ais_hybrid&w=740')",

        //     backgroundImage: "url('https://images.unsplash.com/photo-1554034483-04fda0d3507b?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTR8fGNvbG9yJTIwYmFja2dyb3VuZHxlbnwwfHwwfHx8MA%3D%3D')",




        //     backgroundSize: "cover",
        //     // backgroundPosition: "center",
        //     backgroundRepeat: "no-repeat",
        //     // background: 'inherit'
        // }}>
        //     <form
        //         autoComplete="off"
        //         style={{
        //             display: "flex",
        //             flexDirection: "column",
        //             alignItems: "center",
        //             backgroundColor: "#fff",
        //             padding: "40px 30px",
        //             borderRadius: "12px",
        //             boxShadow: "0 8px 30px rgba(0, 0, 0, 0.1)",
        //             width: "100%",
        //             maxWidth: "400px",
        //         }}
        //     >
        //         <h2 style={{ marginBottom: "20px", color: "#333" }}>Login</h2>

        //         <input
        //             ref={usernameRef}
        //             name="username"
        //             placeholder="Username"
        //             autoComplete="username"
        //             style={{
        //                 padding: "12px",
        //                 marginBottom: "20px",
        //                 borderRadius: "8px",
        //                 border: "1px solid #ccc",
        //                 fontSize: "16px",
        //                 width: "100%",
        //             }}
        //         />

        //         <div style={{
        //             position: "relative",
        //             width: "100%",
        //             marginBottom: "20px"
        //         }}>
        //             {/* <input
        //                 readOnly
        //                 ref={passwordRef}
        //                 type={showPassword ? "text" : "password"}
        //                 name="password"
        //                 onChange={(e) => {
        //                     setData(e.target.value)
        //                 }}
        //                 placeholder="Password"
        //                 autoComplete="current-password"
        //                 style={{
        //                     width: "100%",
        //                     padding: "12px 40px 12px 12px",
        //                     borderRadius: "8px",
        //                     border: "1px solid #ccc",
        //                     fontSize: "16px",

        //                 }}
        //                 onFocus={(e) => e.target.removeAttribute('readOnly')}

        //             /> */}

        //             <input
        //                 ref={passwordRef}
        //                 type={showPassword ? "text" : "password"}
        //                 name="password"
        //                 readOnly
        //                 placeholder="Password"
        //                 autoComplete="new-password"
        //                 onFocus={(e) => e.target.removeAttribute('readOnly')}
        //                 onChange={(e) => {
        //                     setData(e.target.value);
        //                     // You can mark this as manually typed
        //                     setManuallyTyped(true);
        //                 }}
        //                 style={{
        //                     width: "100%",
        //                     padding: "12px 40px 12px 12px",
        //                     borderRadius: "8px",
        //                     border: "1px solid #ccc",
        //                     fontSize: "16px",
        //                     WebkitTextSecurity: showPassword ? 'none' : 'disc', // Chrome mask fallback
        //                     MozTextSecurity: showPassword ? 'none' : 'disc',
        //                     textSecurity: showPassword ? 'none' : 'disc', // some browsers
        //                     backgroundColor: "#fff"
        //                 }}
        //             />
        //             <button
        //                 type="button"
        //                 disabled={data === ''}
        //                 onClick={togglePasswordVisibility}
        //                 style={{
        //                     position: "absolute",
        //                     right: "10px",
        //                     top: "50%",
        //                     transform: "translateY(-50%)",
        //                     background: "none",
        //                     border: "none",
        //                     cursor: "pointer",
        //                     padding: 0,
        //                     color: "#888"
        //                 }}
        //             >
        //                 {!showPassword ? <FaEyeSlash /> : <FaEye />}
        //             </button>
        //         </div>

        //         <button
        //             type="submit"
        //             style={{
        //                 padding: "12px",
        //                 backgroundColor: "#1976d2",
        //                 color: "white",
        //                 border: "none",
        //                 borderRadius: "8px",
        //                 fontSize: "16px",
        //                 cursor: "pointer",
        //                 width: "100%",
        //             }}
        //         >
        //             Login
        //         </button>
        //     </form>
        // </div >


        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
                width: "100%",
                // backgroundImage: "url('https://images.unsplash.com/photo-1554034483-04fda0d3507b?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTR8fGNvbG9yJTIwYmFja2dyb3VuZHxlbnwwfHwwfHx8MA%3D%3D')",


                // backgroundImage: "url('https://img.freepik.com/free-vector/isometric-erp-illustration_52683-84174.jpg?ga=GA1.1.1338093985.1743762455&semt=ais_hybrid&w=740')",


                backgroundImage: "url('https://images.unsplash.com/photo-1557683304-673a23048d34')",

                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
            }}
        >
            <form
                onSubmit={handleSubmit}
                autoComplete="off"
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    backgroundColor: "rgba(255, 255, 255, 0.95)",
                    padding: "40px 30px",
                    borderRadius: "12px",
                    boxShadow: "0 10px 35px rgba(0, 0, 0, 0.2)",
                    width: "100%",
                    maxWidth: "400px",
                    backdropFilter: "blur(6px)"
                }}
            >
                <h2 style={{ marginBottom: "25px", color: "#333", fontWeight: 600 }}>LOGIN</h2>

                <input
                    ref={usernameRef}
                    name="username"
                    placeholder="Email"
                    autoComplete="username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    style={{
                        padding: "12px",
                        marginBottom: "10px",
                        borderRadius: "8px",
                        fontSize: "16px",
                        width: "100%",
                        border: errors.username ? "1px solid red" : "1px solid #ccc",
                    }}
                />

                {errors.username && (
                    <div style={{ color: "red", fontSize: "13px", marginBottom: "10px", alignSelf: "flex-start" }}>
                        {errors.username}
                    </div>
                )}

                <div style={{ position: "relative", width: "100%", marginBottom: "10px", marginTop: '10px' }}>
                    <input
                        ref={passwordRef}
                        type={showPassword ? "text" : "password"}
                        name="password"
                        readOnly
                        placeholder="Password"
                        autoComplete="new-password"
                        onFocus={(e) => e.target.removeAttribute("readOnly")}
                        onChange={(e) => {
                            setData(e.target.value);
                            setPassword(e.target.value);
                            setManuallyTyped(true);
                        }}
                        style={{
                            width: "100%",
                            padding: "12px 40px 12px 12px",
                            borderRadius: "8px",
                            fontSize: "16px",
                            WebkitTextSecurity: showPassword ? "none" : "disc",
                            backgroundColor: "#fff",
                            border: errors.password ? "1px solid red" : "1px solid #ccc",
                        }}
                    />
                    <button
                        type="button"
                        disabled={data === ""}
                        onClick={togglePasswordVisibility}
                        style={{
                            position: "absolute",
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                            padding: 0,
                            color: "#888",
                        }}
                    >
                        {!showPassword ? <FaEyeSlash /> : <FaEye />}
                    </button>
                </div>

                {errors.password && (
                    <div style={{ color: "red", fontSize: "13px", marginBottom: "10px", alignSelf: "flex-start" }}>
                        {errors.password}
                    </div>
                )}

                {/* <div style={{ alignSelf: "flex-end", marginBottom: "20px" }}>
                    <a
                        href="#"
                        style={{
                            textDecoration: "none",
                            color: "#1976d2",
                            fontSize: "14px",
                            fontWeight: 500,
                        }}
                    >
                        Forgot Password?
                    </a>
                </div> */}

                <div style={{ width: "100%", textAlign: "right", marginBottom: "15px" }}>
                    <button type="button" onClick={onForgot} style={styles.linkButton}>
                        Forgot Password?
                    </button>
                </div>


                <button
                    type="submit"
                    style={{
                        padding: "12px",
                        backgroundColor: "#1976d2",
                        color: "white",
                        border: "none",
                        borderRadius: "8px",
                        fontSize: "16px",
                        cursor: "pointer",
                        width: "100%",
                        fontWeight: "bold",
                        letterSpacing: "0.5px",
                    }}
                >

                    {loading ? <div class="spinner-border text-primary color-white" role="status">
                        <span class="sr-only">Loading...</span>
                    </div> : 'Login'}
                </button>
            </form>
        </div>

    );
}




const styles = {
    container: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundImage: "url('https://images.unsplash.com/photo-1554034483-04fda0d3507b?fm=jpg&q=60&w=3000')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        padding: "20px",
    },
    form: {
        backgroundColor: "#fff",
        padding: "40px 30px",
        borderRadius: "12px",
        boxShadow: "0 8px 30px rgba(0, 0, 0, 0.1)",
        width: "100%",
        maxWidth: "400px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    title: {
        marginBottom: "20px",
        color: "#333",
    },
    input: {
        padding: "12px",
        marginBottom: "10px",
        borderRadius: "8px",
        border: "1px solid #ccc",
        fontSize: "16px",
        width: "100%",
    },
    primaryButton: {
        padding: "12px",
        backgroundColor: "#1976d2",
        color: "white",
        border: "none",
        borderRadius: "8px",
        fontSize: "16px",
        cursor: "pointer",
        width: "100%",
        marginTop: "10px",
    },
    linkButton: {
        background: "none",
        border: "none",
        color: "#1976d2",
        fontSize: "14px",
        cursor: "pointer",
        paddingTop: "10px",
        textDecoration: "underline",
    },
    eyeButton: {
        position: "absolute",
        right: "10px",
        top: "50%",
        transform: "translateY(-50%)",
        background: "none",
        border: "none",
        cursor: "pointer",
        color: "#888",
    },
    error: {
        color: "red",
        fontSize: "13px",
        marginBottom: "10px",
        alignSelf: "flex-start",
    },
};



